module.exports = __webpack_public_path__ + "img/12.3246eb49.jpg";